import { useQuery } from '@tanstack/react-query';

import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { useResource, useResources } from '@/lib/datx-jsonapi-react';
import { timezonesList } from '@/lib/time-zones';
import { queryProfileTimezones } from '@/queries/profile-timezones';
import { queryThinEvent } from '@/queries/thin-events';
import { sessionQueryOptions } from '@/queries/upgrade/sessions';

export const useUserEventTimezone = (eventId: string): string => {
  const { timeZone } = useQueryParams<{ timeZone: string }>({
    timeZone: StringParam,
  });

  const { data: session } = useQuery(sessionQueryOptions());
  const profile = session?.main_profile;
  const { data: event } = useResource(queryThinEvent(eventId));
  const { data: profileTimezone } = useResources(queryProfileTimezones(eventId, profile?.id));

  const urlTimeZone = timezonesList.find((tz) => tz === timeZone);

  if (urlTimeZone) return timeZone;
  return profileTimezone?.[0]?.timeZone || event?.timeZone || 'UTC';
};
